import React, { useEffect, useState } from 'react';
import './sidebar.scss';
import { Link, useHistory, useLocation } from 'react-router-dom';
import {
	Box,
	Container,
	Grid,
	makeStyles,
	Divider,
	Avatar,
	Chip,
	Radio,
	RadioGroup,
	FormControlLabel,
	FormControl,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
// import { images } from '../../constants'
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import sidebarNav from '../../configs/sidebarNav';
import sidebarNavT from '../../configs/sidebarNavT';
import { useDispatch, useSelector } from 'react-redux';
import {
	agentloginSuccess,
	travellerloginSuccess,
	walletagentSuccess,
	walletSuccess,
} from '../../reducers/UserReducer';

const Sidebar = () => {
	const [activeIndex, setActiveIndex] = useState(0);
	const location = useLocation();
	const dispatch = useDispatch();
	const history = useHistory();
	const { travellerlogin, agentlogoget } = useSelector((state) => state.user);
	useEffect(() => {
		const curPath = window.location.pathname.split('/')[1];
		console.log(window.location.pathname.split('/')[1]);
		const activeItem = sidebarNav.findIndex((item) => item.section === curPath);

		setActiveIndex(curPath.length === 0 ? 0 : activeItem);
	}, [location]);

	const closeSidebar = () => {
		document.querySelector('.main__content').style.transform =
			'scale(1) translateX(0)';
		setTimeout(() => {
			document.body.classList.remove('sidebar-open');
			document.querySelector('.main__content').style = '';
		}, 500);
	};
	// console.log(agentlogoget.result.substr(50));
	return (
		<div className='sidebar'>
			{/* <div className='sidebar__logo'>
				<Box onClick={() => history.push('/')}>
					<img
						src={`https://flight.musafirbazar.com/api${
							agentlogoget && agentlogoget.result.substr(50)
						}`}
						alt=''
						style={{ cursor: 'pointer', marginTop: 50 }}
					/>
				</Box>

				<div className='sidebar-close' onClick={closeSidebar}>
					<i className='bx bx-x'></i>
				</div>
			</div> */}
			<div className='sidebar__menu' style={{ marginTop: 100 }}>
				{travellerlogin &&
				travellerlogin.result &&
				travellerlogin.result.result &&
				travellerlogin.result.result.role === 'Traveller'
					? sidebarNavT.map((nav, index) => (
							<Link
								to={nav.link}
								key={`nav-${index}`}
								className={`sidebar__menu__item ${
									activeIndex === index && 'active'
								}`}
								onClick={closeSidebar}>
								<div className='sidebar__menu__item__icon'>{nav.icon}</div>
								<div
									className='sidebar__menu__item__txt'
									style={{
										fontSize: 18,
										fontFamily: 'Josefin Sans, sans-serif',
									}}>
									{nav.text}
								</div>
							</Link>
					  ))
					: sidebarNav.map((nav, index) => (
							<Link
								to={nav.link}
								key={`nav-${index}`}
								className={`sidebar__menu__item ${
									activeIndex === index && 'active'
								}`}
								onClick={closeSidebar}>
								<div className='sidebar__menu__item__icon'>{nav.icon}</div>
								<div
									className='sidebar__menu__item__txt'
									style={{
										fontSize: 18,
										fontFamily: 'Josefin Sans, sans-serif',
									}}>
									{nav.text}
								</div>
							</Link>
					  ))}
				{/* {sidebarNav.map((nav, index) => (
					<Link
						to={nav.link}
						key={`nav-${index}`}
						className={`sidebar__menu__item ${
							activeIndex === index && 'active'
						}`}
						onClick={closeSidebar}>
						<div className='sidebar__menu__item__icon'>{nav.icon}</div>
						<div
							className='sidebar__menu__item__txt'
							style={{ fontSize: 20, fontFamily: 'Josefin Sans, sans-serif' }}>
							{nav.text}
						</div>
					</Link>
				))} */}
				<div className='sidebar__menu__item'>
					<div className='sidebar__menu__item__icon'>
						<i class='fa-solid fa-arrow-right-from-bracket'></i>
					</div>
					<div
						className='sidebar__menu__item__txt'
						style={{ fontSize: 18 }}
						onClick={() => {
							dispatch(travellerloginSuccess(null));
							dispatch(agentloginSuccess(null));
							dispatch(walletSuccess(null));
							dispatch(walletagentSuccess(null));
							localStorage.clear();
							history.push('/');
						}}>
						Logout
					</div>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
